module.exports = __webpack_public_path__ + "img/modal_success_icon.fbcc3c33.svg";